import React from "react";

function About() {
  return (
    <main>
        <section className="hero">
            <div>
            <h1>About us</h1>
            <p>hey there!</p>
            </div>
        </section>
    </main>
  );
}

export default About;
